import styled from 'styled-components';

import { mediaTiny } from '@xing-com/layout-tokens';
import {
  scale080,
  scale130,
  scale150,
  spaceM,
  spaceL,
  spaceXL,
  spaceXXL,
  space6XL,
} from '@xing-com/tokens';
import { Hero, Headline, BodyCopy } from '@xing-com/typography';

export const StyledAdvisory = styled.div`
  max-width: 1024px;
  margin: 0px auto;
`;

export const StyledAdvisoryHeader = styled.div`
  display: flex;
  margin-bottom: ${space6XL};
  @media ${mediaTiny} {
    margin-bottom: ${spaceXXL};
  }
`;

export const StyledArticles = styled.div`
  margin: ${spaceL} -${spaceM} -${spaceM} -${spaceM};

  display: block;

  > * {
    margin: ${spaceM};
  }
`;

export const StyledHero = styled(Hero)`
  @media ${mediaTiny} {
    font-size: ${scale150};
    line-height: 1.2;
    margin-bottom: ${spaceXL};
  }
`;

export const StyledBodyCopy = styled(BodyCopy)`
  @media ${mediaTiny} {
    font-size: ${scale080};
    margin-bottom: ${spaceM};
  }
`;

export const StyledListTitle = styled(Headline)`
  font-size: ${scale150};
  line-height: 1.2;
  margin-bottom: ${spaceXL};

  @media ${mediaTiny} {
    font-size: ${scale130};
    line-height: 1.2;
    margin-bottom: ${spaceL};
  }
`;
